import {
  CmsFormField,
  PlanDocumentsFormField,
} from '@domgen/dgx-fe-business-models';

export type PlanDocumentFieldTypes =
  CmsFormField<PlanDocumentsFormField.Paperless>;

export type PlanDocumentFormFields = Array<PlanDocumentFieldTypes>;
